import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 400px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: var(--glass-1);
  padding: 30px;
  border-radius: 16px;
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
`;

const TopDeco = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #022069, var(--accent));
`;

const LogoHolder = styled.div`
  font-weight: 900;
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
  span { color: var(--accent); }
`;

const Input = styled.input`
  width: 100%;
  background: rgba(0,0,0,0.2);
  border: 1px solid var(--glass-border);
  border-radius: 8px;
  padding: 12px;
  color: #fff;
  margin-bottom: 12px;
  outline: none;
`;

const Button = styled.button`
  width: 100%;
  background: #022069;
  color: #fff;
  border: 1px solid #0336a6;
  border-radius: 8px;
  padding: 14px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(2, 32, 105, 0.4);
  transition: background 0.2s;

  &:hover { background: #0336a6; }
`;

const HelpText = styled.div`
  text-align: center;
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 20px;
  a { color: var(--accent); text-decoration: none; }
`;

const CustomerLoginWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align}>
      <TopDeco />
      <LogoHolder>Mein <span>O₂</span></LogoHolder>
      <div style={{textAlign:'center', marginBottom: 20, color:'var(--text-secondary)'}}>
        {node.content?.title || 'Logge dich mit deinen Daten ein.'}
      </div>
      <form onSubmit={e => e.preventDefault()}>
        <Input type="text" placeholder="Benutzername oder Rufnummer" />
        <Input type="password" placeholder="Kennwort" />
        <Button className="tef-bubbles">Einloggen</Button>
      </form>
      <HelpText>
        Kennwort vergessen? <a href="#">Hier zurücksetzen</a>
      </HelpText>
    </Wrapper>
  );
};

registry.register('customer_login', {
  label: 'Mein O2 Login',
  icon: '👤',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center' } },
  render: CustomerLoginWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Text', fields: [{name:'content.title', label:'Untertitel', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
